// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Textarea_wrapper__Iyj81","textarea":"Textarea_textarea__p7a8S","hideLabel":"Textarea_hideLabel__7vOtS"};